import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import { Typography } from '@/components/Typography';
import { cn } from '@/lib/cn';
export type PageSubNavLinkProps = {
  href: string;
  children: ReactNode;
  active?: boolean;
};
export function PageSubNavLink(t0) {
  const $ = _c(7);
  const {
    href,
    children,
    active
  } = t0;
  const t1 = !active;
  let t2;
  if ($[0] !== active || $[1] !== t1) {
    t2 = cn("tab relative z-1 input-focus-transition rounded-full px-4 py-2 text-primary bg-transparent whitespace-nowrap select-none", {
      "bg-primary text-white": active,
      "hover:bg-primary-light hover:text-white": t1
    });
    $[0] = active;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== children || $[4] !== href || $[5] !== t2) {
    t3 = <Typography as="a" variant="paragraph-heavy" href={href} draggable={false} className={t2}>{children}</Typography>;
    $[3] = children;
    $[4] = href;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}